import React, {useContext} from 'react';
import {noop} from '@priority-software/priority-style-react';
import {ruleDialogID} from '../../../../../../../constants';
import {AIHelperDropdown} from '../../../../../../../../../components/AIHelper/AIHelperDropdown';
import {getAIContentEnhancement} from '../../../../../../../../../components/LexicalEditor/plugins/EmailWritingAssistantPlugin/actions';
import {
    unwrapHtmlParagraph,
    wrapIntoHTML
} from '../../../../../../../../../components/AIHelper/utils';
import {RuleDialogContext} from '../../../../../../RulesListDialog/context';
import {AlertMessageFields} from '../../../../../../../enums';
import {supportAIBlock} from '../../../../../../../utils';

type Props = {
    handleMessageData: (field: string, val: string) => void;
    messageLang: number;
    currentMessage: string;
};

export const AIContentAssistant = (props: Props) => {
    const {handleMessageData, messageLang, currentMessage} = props;
    const {setAiLoading} = useContext(RuleDialogContext);

    const onSelect = async (enhancementType: string, enhancementOption?: string) => {
        if (currentMessage) {
            getAIContentEnhancement(
                {
                    content: wrapIntoHTML(currentMessage),
                    enhancementType,
                    enhancementOption,
                    language: messageLang === 3 ? 'en' : 'he'
                },
                {
                    onLoading: setAiLoading,
                    handleResult: html => {
                        handleMessageData(AlertMessageFields.Message, unwrapHtmlParagraph(html));
                    },
                    onSuccess: noop,
                    onErrorClose: () => {
                        requestAnimationFrame(() => {});
                    }
                }
            );
        }
    };

    if (!supportAIBlock()) return null;

    return <AIHelperDropdown onSelect={onSelect} portalId={ruleDialogID} linkHoverEffect />;
};
